<template>
    <nav>
        <div class="survey-question-image-editor">
            <img v-if="question.imageDisplay != null" :src="question.imageDisplay" :path="question.image"
                class="custom-image large">
            <img v-else src="/assets/editor_images/surveyimagequestion.jpg" class="custom-image large">
        </div>
        <v-list v-if="role == 'booster'" class="mt-7 pa-0 disable-events" :style="`background-color:` + question.bg_color">
            <v-list-item v-for="answer in question.options" :key="answer.aid">
                <v-text-field readonly disabled dense solo elevation="8" class="survey-answer-block rounded-lg text-body-2"
                    hide-details="auto">
                    <template v-slot:prepend-inner>
                        <v-icon class="icon-des my-2" color="greytext">mdi-checkbox-blank-outline</v-icon>
                        <p data-testid="select-answer"
                            class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break">
                            {{ answer.option }}
                        </p>
                    </template>
                </v-text-field>
            </v-list-item>
        </v-list>
        <v-list v-else class="mt-7 pa-0" :style="`background-color:` + question.bg_color">
            <v-list-item v-for="answer in question.options" :key="answer.aid" class="no-hover"
                :class="answer.answer ? 'selected' : 'not-selected'" :ripple="false" @click="answerQuestion(answer)">
                <v-text-field readonly disabled dense solo elevation="8" class="survey-answer-block rounded-lg text-body-2"
                    hide-details="auto" :key="updateComponent">
                    <template v-slot:prepend-inner>
                        <v-icon v-if="answer.answer" class="icon-des my-2 row-pointer"
                            color="greytext">mdi-checkbox-outline</v-icon>
                        <v-icon v-else class="icon-des my-2 row-pointer"
                            color="greytext">mdi-checkbox-blank-outline</v-icon>

                        <p data-testid="select-answer"
                            class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break row-pointer">
                            {{ answer.option }}
                        </p>
                    </template>
                </v-text-field>
            </v-list-item>
        </v-list>
        <p v-if="showError" class="error--text font-italic">{{ $t('answerError') }}</p>
    </nav>
</template>
<script>

export default {
    props: {
        question: {
            type: Object,
            default: () => { }
        },
        role: {
            type: String,
            default: 'booster'
        },
        invalidAnswers: {
            type: Array,
            default: () => []
        },
        hasSubmittedSurvey: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            updateComponent: '',
            answerObject: {
                type: this.question.type,
                id: this.question.id,
                selections: []
            },
            showError: false
        }
    },
    created() {
        this.$emit('sendAnswer', this.answerObject)
    },
    watch: {
        invalidAnswers() {
            this.showError = false
            if (this.hasSubmittedSurvey && this.invalidAnswers.includes(this.question.id)) {
                this.showError = true
            }
        },
    },
    methods: {
        answerQuestion(answer) {
            answer.answer = !answer.answer
            this.updateComponent = Date.now()
            if (answer.answer) {
                this.answerObject.selections.push(answer.aid)
            } else {
                this.answerObject.selections.splice(this.answerObject.selections.indexOf(answer.aid), 1)
            }
            this.$emit('sendAnswer', this.answerObject)
        }
    }
}
</script>
<style scope>
.survey-answer-block .v-input__slot {
  display: block !important;
}
.survey-answer-block .v-text-field__slot {
  height: 0;
}
</style>